import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  FACILITATOR_VALIDATION_CLEAR,
  FACILITATOR_VALIDATION_DELAY,
  FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST_REQUEST,
} from '../../../../actions/actionTypes';

const delay = fetchReducerGenerator(
  [
    FACILITATOR_VALIDATION_CLEAR,
    FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST_REQUEST,
  ],
  FACILITATOR_VALIDATION_DELAY
);

export default delay;

export const getFacilitatorValidationDelayIsSuccess = state =>
  state.response && state.response.status === HttpStatus.NO_CONTENT.value;
